var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2212_32423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 7.70983C14.6666 11.232 11.6814 14.0876 7.99992 14.0876C7.56705 14.0882 7.13539 14.0482 6.71019 13.9684C6.40414 13.9108 6.25111 13.8821 6.14427 13.8984C6.03743 13.9148 5.88604 13.9952 5.58325 14.1563C4.72668 14.6118 3.72789 14.7727 2.76733 14.594C3.13241 14.145 3.38175 13.6062 3.49177 13.0286C3.55844 12.6752 3.39325 12.332 3.14585 12.0808C2.02214 10.9397 1.33325 9.4021 1.33325 7.70983C1.33325 4.18774 4.31844 1.33203 7.99992 1.33203C11.6814 1.33203 14.6666 4.18774 14.6666 7.70983Z",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99692 8H8.00292H7.99692ZM10.6606 8H10.6666H10.6606ZM5.33325 8H5.33923H5.33325Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99692 8H8.00292M10.6606 8H10.6666M5.33325 8H5.33923",
    stroke: "#B0B0B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2212_32423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.5ca8c7f6bf0b9f2286ddfb8783d244c9.svg";
export { ForwardRef as ReactComponent };